import { render, staticRenderFns } from "./TotalSuggestions.vue?vue&type=template&id=1276f068&scoped=true&"
import script from "./TotalSuggestions.vue?vue&type=script&lang=js&"
export * from "./TotalSuggestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1276f068",
  null
  
)

export default component.exports